/* eslint-disable no-param-reassign */
import { create } from 'zustand';
import { produce } from 'immer';
import { availableTutorials } from './availableTutorials';

/**
 * This store is to be used by the hook useTutorial only
 * No other component should use this store
 */

/**
 * queue: Array of tutorial names that have been marked eligible for drive
 * isAttribBound: Function to check if a data attribute is marked as extracted
 * bindAttrib: Function to mark a data attribute as extracted
 */

export const useTutorialStore = create((set, get) => ({
	tutorials: [],
	queue: [],
	initialized: true,
	isInitialized: () => get().initialized,
	getTutorial: ({ tutorialName }) => {
		const tutorial = get().tutorials?.find(tut => tut.tutorialName === tutorialName);
		if (tutorial) {
			return tutorial;
		}
		if (tutorialName && Object.values(availableTutorials).includes(tutorialName)) {
			const newTutorial = { tutorialName, boundStepAttribs: {} };
			set(state =>
				produce(state, draft => {
					draft.tutorials.push(newTutorial);
				})
			);
			return get().tutorials?.find(tut => tut.tutorialName === tutorialName);
		}
		return null;
	},
	pushToQueue: tutorialName => {
		set(state =>
			produce(state, draft => {
				if (!draft.queue.includes(tutorialName)) {
					draft.queue.push(tutorialName);
				}
			})
		);
	},
	popFromQueue: tutorialName => {
		set(state =>
			produce(state, draft => {
				if (draft.queue.length > 0) {
					if (tutorialName) {
						const index = draft.queue.indexOf(tutorialName);
						if (index > -1) {
							draft.queue.splice(index, 1);
						}
					} else {
						draft.queue.shift();
					}
				}
			})
		);
	},
	isAttribBound: (tutorialName, attrib) => {
		const tutorial = get().tutorials?.find(tut => tut.tutorialName === tutorialName);
		if (tutorial) {
			return tutorial.boundStepAttribs[attrib];
		}
		return null;
	},
	bindAttrib: (tutorialName, attrib) => {
		set(state =>
			produce(state, draft => {
				const tutorial = draft.tutorials?.find(tut => tut.tutorialName === tutorialName);
				if (tutorial) {
					tutorial.boundStepAttribs[attrib] = true;
				}
			})
		);
	},
	resetTutorial: () => set(() => ({ queue: [], tutorials: [], initialized: true })),
}));
